import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';

import Layout from '@/components/Layout';
import ProtectedRoute from '@/components/ProtectedRoute';
import Landing from '@/pages/Landing';
import Login from '@/pages/Login';
import Home from '@/pages/Home';
import Interview from '@/pages/Interview';
import Results from '@/pages/Results';
import History from '@/pages/History';
import Stats from '@/pages/Stats';
import Profile from '@/pages/Profile';
import Jobs from '@/pages/Jobs';
import Admin from '@/pages/Admin';
import AdminJobs from '@/pages/AdminJobs';

// Wrap a page with the shared Layout
const withLayout = (node) => <Layout>{node}</Layout>;

function App() {
    return (
        <div className="App">
            <Toaster position="top-right" richColors />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/login" element={<Login />} />

                    <Route
                        path="/home"
                        element={<ProtectedRoute>{withLayout(<Home />)}</ProtectedRoute>}
                    />
                    <Route
                        path="/interview/:sessionId"
                        element={<ProtectedRoute>{withLayout(<Interview />)}</ProtectedRoute>}
                    />
                    <Route
                        path="/results/:sessionId"
                        element={<ProtectedRoute>{withLayout(<Results />)}</ProtectedRoute>}
                    />
                    <Route
                        path="/history"
                        element={<ProtectedRoute>{withLayout(<History />)}</ProtectedRoute>}
                    />
                    <Route
                        path="/stats"
                        element={<ProtectedRoute>{withLayout(<Stats />)}</ProtectedRoute>}
                    />
                    <Route
                        path="/profile"
                        element={<ProtectedRoute>{withLayout(<Profile />)}</ProtectedRoute>}
                    />
                    <Route
                        path="/jobs"
                        element={<ProtectedRoute>{withLayout(<Jobs />)}</ProtectedRoute>}
                    />
                    <Route
                        path="/admin"
                        element={<ProtectedRoute adminOnly>{withLayout(<Admin />)}</ProtectedRoute>}
                    />
                    <Route
                        path="/admin/jobs"
                        element={<ProtectedRoute adminOnly>{withLayout(<AdminJobs />)}</ProtectedRoute>}
                    />

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
